import {Component, Input, OnInit} from '@angular/core';
import {GetId} from '../../_utils/get-id';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss']
})
export class CardComponent extends GetId implements OnInit {

  @Input() title: string;
  @Input() subtitle: string;

  cardId = this.getId();

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
